var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.5V6.5V4.5ZM6 8.5H6.005H6ZM10.5 6.5C10.5 7.09095 10.3836 7.67611 10.1575 8.22208C9.93131 8.76804 9.59984 9.26412 9.18198 9.68198C8.76412 10.0998 8.26804 10.4313 7.72208 10.6575C7.17611 10.8836 6.59095 11 6 11C5.40905 11 4.82389 10.8836 4.27792 10.6575C3.73196 10.4313 3.23588 10.0998 2.81802 9.68198C2.40016 9.26412 2.06869 8.76804 1.84254 8.22208C1.6164 7.67611 1.5 7.09095 1.5 6.5C1.5 5.30653 1.97411 4.16193 2.81802 3.31802C3.66193 2.47411 4.80653 2 6 2C7.19347 2 8.33807 2.47411 9.18198 3.31802C10.0259 4.16193 10.5 5.30653 10.5 6.5Z",
    stroke: "#EF5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.d46632d2.svg";
export { ForwardRef as ReactComponent };